import * as React from 'react';
import * as ReactNative from 'react-native';
import { Provider as PaperProvider } from 'react-native-paper';
import { Provider as StoreProvider } from 'react-redux';
import store from './redux/store';
import { Routes } from './routes';
import { theme } from './configs/theme';
import ErrorBoundary from './components/ErrorBoundary';
import 'moment/locale/ja';
// import { PersistGate } from 'redux-persist/integration/react';

declare global {
  interface Window {
    ReactNative: any;
    React: any;
  }
}

window.React = React;
window.ReactNative = ReactNative;
ReactNative.LogBox.ignoreAllLogs(true);

export default function App() {
  // Hide the native splash screen as soon as the app mounts. Otherwise it is
  // only dismissed once app data finishes loading, which never happens offline
  // — leaving the splash covering the UI (so alerts stay hidden) and tripping
  // the iOS launch watchdog. Hiding it here, at the earliest point, guarantees
  // the app presents its real UI regardless of network state.
  React.useEffect(() => {
    if (ReactNative.Platform.OS === 'web') return;
    (async () => {
      try {
        const SplashScreen = (await import('react-native-splash-screen'))
          .default;
        SplashScreen?.hide();
      } catch (error) {
        console.error('SplashScreen hide error: ', error);
      }
    })();
  }, []);

  return (
    <ErrorBoundary>
      <StoreProvider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <PaperProvider theme={theme}>
          <Routes />
        </PaperProvider>
        {/* </PersistGate> */}
      </StoreProvider>
    </ErrorBoundary>
  );
}
